import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

const GET_DOCUMENTS_LIST = gql`
  mutation getTransactionsDocumentsByUserId(
    $page: Int!
    $limit: Int!
    $firebaseId: String!
    $search: String
  ) {
    getTransactionsDocumentsByUserId(
      page: $page
      limit: $limit
      firebaseId: $firebaseId
      search: $search
    ) {
      success
      message
      totalRecords
      totalPages
      currentPage
      transactionDocuments {
        transactionId
        transactionProperty {
          type
          location
          address
          city
          state
          zipCode
          purchasePrice
          closingDate
          notes
          latitude
          longitude
        }
        transactionCreatedName
        transactionStatus
        municipalityId
        municipalityName
        documentType
        otherDocumentType
        firebaseId
        title
        notes
        docUrl
        docKey
        docUniqueId
        docContentType
        uploadedDate
        uploadedBy
        docCreatedInfo
      }
    }
  }
`;

export function useGetDocumentsList() {
  return useMutation(GET_DOCUMENTS_LIST);
}
